/*eslint-disable*/
import React, { useState, useEffect } from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl";
// import FormLabel from '@mui/material/FormLabel'; 
//import FormControlLabel from "@material-ui/core/FormControlLabel";
// material ui icons
import MailOutline from "@material-ui/icons/MailOutline";
import Slider from "nouislider";
import ImageUpload from "components/CustomUpload/ImageUpload.js";
// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardIcon from "components/Card/CardIcon.js";
import CardBody from "components/Card/CardBody.js";
import Datetime from "react-datetime";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import axios from "axios";
import SweetAlert from "react-bootstrap-sweetalert";
import defaultImage from "assets/img/image_placeholder.jpg";
import defaultAvatar from "assets/img/placeholder.jpg";
import draftToHtml from 'draftjs-to-html';
import { convertFromRaw, convertFromHtml } from 'draft-js';
// style for this view
import styles from "assets/jss/material-dashboard-pro-react/views/validationFormsStyle.js";
import reactDom from "react-dom";
import RichTextEditor from "react-rte";
import stylesData from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.js";
import TransferPrivateInvestors from "./TransferPrivateInvestors";
//const baseURL = "https://jsonplaceholder.typicode.com/api/v1/admin/login";
const useStyleData = makeStyles(stylesData);


const useStyles = makeStyles(styles);

export default function ManageICOPage() {

  const [formValues, setFormValues] = React.useState({
    startInvTimeStamp: "",
    endInvTimeStamp: "",
    maxToken: 0,
    tokenPrice: 0,
    peterAddress: "",
    ronAddress: "",
    icoDoc: [],
  });
  const [transferValues, setTransferValues] = React.useState({
    peterAddress: "",
    ronAddress: ""
  });

  const [loading, setLoading] = React.useState(true);
  const [alert, setAlert] = React.useState(null);
  const [selectedDate, setSelectedDate] = React.useState(null);
  const [selectedTime, setSelectedTime] = React.useState(null);
  const [data1, setData1] = useState([]);
  const [data2, setData2] = useState([]);
  const [data3, setData3] = useState([]);
  const [data4, setData4] = useState([]);
  const [data5, setData5] = useState([]);
  const [imageurl1, setImageurl1] = React.useState('');
  const [avatar, setAvatar] = React.useState(true);
  const [file1, setFile1] = React.useState(null);
  const [selectedFile1, setSelectedFile1] = React.useState(null);
  useEffect(() => {
    // Define your API endpoints
    setLoading(false);
    const token = localStorage.getItem("token");
    const apiUrl1 = `${process.env.REACT_APP_API_URL_PREFIX}/api/v1/admin/getMervCoinName`;
    const apiUrl2 = `${process.env.REACT_APP_API_URL_PREFIX}/api/v1/admin/getMervCoinSymbol`;
    const apiUrl3 = `${process.env.REACT_APP_API_URL_PREFIX}/api/v1/admin/getInvestmentMervCoin`;
    const apiUrl4 = `${process.env.REACT_APP_API_URL_PREFIX}/api/v1/admin/getUserMervCoin`;
    const apiUrl5 = `${process.env.REACT_APP_API_URL_PREFIX}/api/v1/admin/fetchInvStartEndTime`;
    // Create an array of Axios GET requests


    // Make four parallel Axios GET requests
    axios.get(apiUrl1,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Access-Control-Allow-Origin": "*",
        },
      }
    )
      .then((response) => {
        setData1(response.data);
        console.log(data1, "data1")
      })
      .catch((error) => {
        console.error('Error fetching data 1:', error);
      });

    axios.get(apiUrl2,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Access-Control-Allow-Origin": "*",
        },
      }
    )
      .then((response) => {
        setData2(response.data);
        console.log(data2, "data1")
      })
      .catch((error) => {
        console.error('Error fetching data 2:', error);
      });

    axios.get(apiUrl3,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Access-Control-Allow-Origin": "*",
        },
      }
    )
      .then((response) => {
        setData3(response.data);
        console.log(data3, "data1")
      })
      .catch((error) => {
        console.error('Error fetching data 3:', error);
      });

    axios.get(apiUrl4,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Access-Control-Allow-Origin": "*",
        },
      }
    )
      .then((response) => {
        setData4(response.data);
        console.log(data4, "data1")
      })
      .catch((error) => {
        console.error('Error fetching data 4:', error);
      });

    axios.get(apiUrl5,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Access-Control-Allow-Origin": "*",
        },
      }
    )
      .then((response) => {
        console.log("response5", response.data.data[0])
        // setData5(response.data.data[0]);
        setFormValues({
          startInvTimeStamp: response.data.data[0]?.startInvTimeStamp,
          endInvTimeStamp: response.data.data[0]?.endInvTimeStamp,
          maxToken: response.data.data[0]?.maxToken,
          tokenPrice: response.data.data[0]?.tokenPrice,
          icoDoc: response.data.data[0]?.icoDoc,
        })
      })
      .catch((error) => {
        console.error('Error fetching data 1:', error);
      });
  }, []);

  // Define a validation function to check if the date is valid
  const isValidDate = (current) => {
    const now = new Date(); // Get the current date and time
    now.setHours(0, 0, 0, 0); // Set time to 00:00:00 to ignore the time portion
    return current >= now; // Return true if the entered date is after the current date
  };

  const hideAlert = () => {
    setAlert(null);
console.log("kkk")
  };

  const handleImageChange1 = async (e) => {
    e.preventDefault();
    let reader = new FileReader();
    let file = e.target.files[0];
    setSelectedFile1(e.target.files[0]);
    setFile1(file);
    reader.onloadend = () => {
      setAvatar(true);
      setImageurl1(e.target.files[0])
    };
    if (file) {
      reader.readAsDataURL(file);
    }
  };

  const handleChange = (e) => {
    setFormValues({
      ...formValues,
      [e.target.id]: e.target.value,
    });
    console.log(formValues);
  };

  const handleEndDateTimeChange = (event) => {
    const date = new Date(event._d);
    setSelectedDate(date.toISOString().split("T")[0]); // Extract date in yyyy-mm-dd format
    setSelectedTime(date.toISOString().split("T")[1].substring(0, 5)); // Extract time in hh:mm format
    console.log(selectedDate, selectedTime);
    setFormValues({
      ...formValues,
      endInvTimeStamp: date.toISOString(),
    });
    console.log(formValues);
  };

  const handleStartDateTimeChange = (event) => {
    const date = new Date(event._d);
    setSelectedDate(date.toISOString().split("T")[0]); // Extract date in yyyy-mm-dd format
    setSelectedTime(date.toISOString().split("T")[1].substring(0, 5)); // Extract time in hh:mm format
    console.log(selectedDate, selectedTime);
    setFormValues({
      ...formValues,
      startInvTimeStamp: date.toISOString(),
    });
    console.log(formValues);
  };


  const handleSubmitTransferRon = async () => {
    const token = localStorage.getItem("token");
    const receiverValue = {
      receiver: formValues.ronAddress,
    };
    axios.post(
      `${process.env.REACT_APP_API_URL_PREFIX}/api/v1/admin/ronMervTransfer`,
      receiverValue,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Access-Control-Allow-Origin": "*",
        }
      }

    )
      .then((res) => {
        setAlert(
          <SweetAlert
            style={{ display: "block", marginTop: "-100px" }}
            title={
              <span
                style={{
                  fontSize: "14px",
                  fontWeight: "bold",
                }}
              >
                {res.data.message}
              </span>
            }
            onConfirm={() => hideAlert()}
            onCancel={() => hideAlert()}
            titleCssClass={classesSweetAlert.cardTitle}
            confirmBtnCssClass={
              classesSweetAlert.button + " " + classesSweetAlert.success
            }
          />
        );
      })
      .catch((err) => {
        console.warn(err);
      })
  }

  const handleSubmitTransferPeter = async (formValues) => {
    console.log(formValues, "formValues.peterAddress")
    const token = localStorage.getItem("token");
    const receiverValue = {
      receiver: formValues.peterAddress,
    };
    axios.post(
      `${process.env.REACT_APP_API_URL_PREFIX}/api/v1/admin/peterMervTransfer`,
      receiverValue,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Access-Control-Allow-Origin": "*",
        }
      }

    )
      .then((res) => {
        setAlert(
          <SweetAlert
            style={{ display: "block", marginTop: "-100px" }}
            title={
              <span
                style={{
                  fontSize: "14px",
                  fontWeight: "bold",
                }}
              >
                {res.data.message}
              </span>
            }
            onConfirm={() => hideAlert()}
            onCancel={() => hideAlert()}
            titleCssClass={classesSweetAlert.cardTitle}
            confirmBtnCssClass={
              classesSweetAlert.button + " " + classesSweetAlert.success
            }
          />
        );
      })
      .catch((err) => {
        console.warn(err);
      })
  }

  const handleSubmitForm = async () => {
    console.log("kkkk", selectedFile1)
    const formData = new FormData();
    formData.append('startInvTimeStamp', formValues.startInvTimeStamp);
    formData.append('endInvTimeStamp', formValues.endInvTimeStamp);
    formData.append('maxToken', formValues.maxToken);
    formData.append('tokenPrice', formValues.tokenPrice);
    formData.append("icoDoc", selectedFile1);
    const token = localStorage.getItem("token");
    axios.put(`${process.env.REACT_APP_API_URL_PREFIX}/api/v1/admin/setInvStartEndTime`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Access-Control-Allow-Origin": "*",
        }
      }

    ).then((res) => {
      setAlert(
        <SweetAlert
          style={{ display: "block", marginTop: "-100px" }}
          title={
            <span
              style={{
                fontSize: "14px",
                fontWeight: "bold",
              }}
            >
              {res.data.message}
            </span>
          }
          onConfirm={() => hideAlert()}
          onCancel={() => hideAlert()}
          titleCssClass={classesSweetAlert.cardTitle}
          confirmBtnCssClass={
            classesSweetAlert.button + " " + classesSweetAlert.success
          }
        />
      );
    })
      .catch((err) => {
        console.warn(err);
      })
  }

  const classes = useStyles();
  const classesSweetAlert = useStyleData();
  return (
    <div>
      {loading && <div>Loading</div>}
      {!loading && (
        <GridContainer>
          <GridItem xs={12} sm={12} md={12}>
            <Card>
              <CardHeader color="rose" icon>
                <CardIcon color="rose">
                  <MailOutline />
                </CardIcon>
                <h4 className={classes.cardIconTitle}>Manage ICO Page</h4>
              </CardHeader>
              <CardBody>
                <form>
                  <GridContainer>
                    <GridItem xs={12} sm={12} md={3}>
                      <h4 className={classes.cardIconTitle}>Coin Name</h4>
                      <CustomInput
                        id="coinName"
                        handleChange={handleChange}
                        formControlProps={{
                          fullWidth: true,
                        }}
                        inputProps={{
                          type: "text",
                          value: data1?.data
                        }}
                      />
                    </GridItem>
                    <GridItem xs={12}>
                      <h4 className={classes.cardIconTitle}>Coin Symbol</h4>
                      <CustomInput
                        id="coinSymbol"
                        handleChange={handleChange}
                        formControlProps={{
                          fullWidth: true,
                        }}
                        inputProps={{
                          type: "text",
                          value: data2?.data
                        }}
                      /></GridItem>
                    <GridItem xs={12} sm={12} md={3}>
                      <h4 className={classes.cardIconTitle}>Investor Balance</h4>
                      <CustomInput
                        id="investorBalance"
                        handleChange={handleChange}
                        formControlProps={{
                          fullWidth: true,
                        }}
                        inputProps={{
                          type: "text",
                          value: data3?.data
                        }}
                      />
                    </GridItem>
                    <GridItem xs={12} sm={12} md={3}>
                      <h4 className={classes.cardIconTitle}>User Balance</h4>
                      <CustomInput
                        id="userBalance"
                        handleChange={handleChange}
                        formControlProps={{
                          fullWidth: true,
                        }}
                        inputProps={{
                          type: "text",
                          value: data4?.data
                        }}
                      />
                    </GridItem>
                    <GridItem xs={12}>
                      <h4 className={classes.cardIconTitle}>Sent Peter Investor Balance</h4>
                      <CustomInput
                        id="peterAddress"
                        handleChange={handleChange}
                        formControlProps={{
                          fullWidth: true,
                        }}
                        inputProps={{
                          type: "text",
                          value: formValues?.peterAddress
                        }}
                      />
                      <Button
                        color="rose"
                        className={classes.registerButton}
                        onClick={() => { handleSubmitTransferPeter(formValues) }}
                      >
                        Transfer
                      </Button>
                    </GridItem>
                    <GridItem xs={12}>
                      <h4 className={classes.cardIconTitle}>Sent Ron Investor Balance</h4>
                      <CustomInput
                        id="ronAddress"
                        handleChange={handleChange}
                        formControlProps={{
                          fullWidth: true,
                        }}
                        inputProps={{
                          type: "text",
                          value: formValues?.ronAddress
                        }}
                      />
                      <Button
                        color="rose"
                        className={classes.registerButton}
                        onClick={handleSubmitTransferRon}
                      >
                        Transfer
                      </Button>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={3}>
                      <form>
                        <h4 className={classes.cardIconTitle}>Set Timeout for Investor</h4>
                        <GridItem xs={12} sm={12} md={12}>
                          <h6 className={classes.cardIconTitle}> Start Investor TimeStamp:</h6>
                          <br />
                          <FormControl fullWidth>
                            <Datetime
                              onChange={handleStartDateTimeChange}
                              inputProps={{ value: formValues.startInvTimeStamp }}
                              isValidDate={isValidDate} // Add the isValidDate prop to enable validation for endDate
                              renderInvalid={(current) => renderInvalidEndDate} // Add the renderInvalid prop to display the error message for endDate                   
                            />
                          </FormControl>
                        </GridItem>
                        <GridItem xs={12} sm={12} md={12}>
                          <h6 className={classes.cardIconTitle}> End Investor TimeStamp:</h6>
                          <br />
                          <FormControl fullWidth>
                            <Datetime
                              onChange={handleEndDateTimeChange}
                              inputProps={{ value: formValues.endInvTimeStamp }}
                              isValidDate={isValidDate} // Add the isValidDate prop to enable validation for endDate
                              renderInvalid={(current) => renderInvalidEndDate} // Add the renderInvalid prop to display the error message for endDate
                            />
                          </FormControl>
                        </GridItem>
                        <h6 className={classes.cardIconTitle}> Maximum user purchase coin:</h6>
                        <CustomInput
                          id="maxToken"
                          handleChange={handleChange}
                          formControlProps={{
                            fullWidth: true,
                          }}
                          inputProps={{
                            type: "text",
                            value: formValues?.maxToken
                          }}
                        />
                        <h6 className={classes.cardIconTitle}>Coin price:</h6>
                        <CustomInput
                          id="tokenPrice"
                          handleChange={handleChange}
                          formControlProps={{
                            fullWidth: true,
                          }}
                          inputProps={{
                            type: "text",
                            value: formValues?.tokenPrice
                          }}
                        />
                        <h6>White paper document upload:</h6>
                        <Button>
                          <input
                            type="file"
                            avatar
                            fileValue={file1}
                            // imagePreviewUrlValue={imagePreviewUrl1}
                            onChange={(e)=>handleImageChange1(e)}
                          />
                        </Button>
                        <Button
                          color="rose"
                          className={classes.registerButton}
                          onClick={handleSubmitForm}
                        >
                          Submit
                        </Button>
                      </form>
                    </GridItem>
                  </GridContainer>
                </form>

              </CardBody>
            </Card>
          </GridItem>
          {alert}
        </GridContainer>
      )}
    </div>
  );
}

